module.exports = __webpack_public_path__ + "img/kommune-2027.1ba2f77b.svg";